import { VertSpacerMd } from '@apps-common/components/layout'

export const ContactCardSkeleton = () => (
  <div className='rounded-3xl w-full p-6 bg-skeleton border border-skeleton-border sm:max-w-[320px]'>
    <div className='w-full animate-pulse'>
      <div className='flex items-center justify-end gap-[5px]'>
        <div className='avatar'>
          <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
        <div className='avatar'>
          <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
      </div>
      <VertSpacerMd />
      <div className='bg-skeleton-hi w-[50%] h-[20px] rounded-[10px]' />
      <VertSpacerMd />
      <div className='bg-skeleton-hi w-[80%] h-[20px] rounded-[10px]' />
    </div>
  </div>
)
